// Build-time configuration constants.
//
// GRAPH_CLIENT_ID: the Entra (Azure AD) application (client) ID for NAA/Graph
// mailbox access. A client ID is a public identifier (not a secret — it appears
// in every auth redirect and token), so hardcoding it here is safe and avoids
// per-user configuration: paste your single multi-tenant registration's client
// ID below and every user gets Graph access with no setup.
//
// Leave empty to disable Graph by default and fall back to EWS (on-premises
// Exchange). The Settings "Graph client ID" field still overrides this value
// when set, for anyone who needs to point at a different registration.
export const GRAPH_CLIENT_ID = "4d32d9e5-7cec-4606-abf0-6bf660e92fef";

// Default AI provider configuration (build-time, overridable per-user via
// Settings). Mirrors GRAPH_CLIENT_ID: paste deploy-wide defaults here so users
// get a working setup with no manual configuration.
//
// Defaults target a local Ollama server exposing the OpenAI-compatible API.
// Ollama needs no API key, and http is fine because localhost is a secure
// context (see isValidBaseUrl / isLoopbackHost in settings.ts).
export const DEFAULT_BASE_URL = "http://localhost:11434/v1";
export const DEFAULT_API_KEY = "";
export const DEFAULT_MODEL = "gpt-oss:120b-cloud";

// Default application name shown in the task pane header and browser tab title.
// Overridable at runtime via `appName` in `config.json` (see policy.ts) without
// a rebuild. `scripts/rename-addin.sh` rewrites this constant at build time for
// deployments that want a permanent rename (it also updates manifest.json,
// which has no runtime configuration channel — see gap-5).
export const DEFAULT_APP_NAME = "AI Assistant";

// Default OTLP telemetry endpoint (build-time, overridable per-user via Settings
// or per-org via config.json — see ADR-006). Empty by default: telemetry has no
// built-in vendor or destination — an organization pastes its own self-hosted
// OTLP-compatible endpoint (e.g. a self-hosted Langfuse instance's OTLP route)
// here or in config.json to give every user a working default without per-user
// setup. Telemetry stays off (see settings.ts DEFAULTS.telemetryEnabled) even
// when an endpoint is configured — opt-in is a separate switch.
export const DEFAULT_TELEMETRY_ENDPOINT = "";
